var _path, _ellipse, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilitiModeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16.5079C32 25.625 24.6154 34.2857 16 40C6.76923 33.6508 0 25.625 0 16.5079C0 7.39086 7.16344 0 16 0C24.8366 0 32 7.39086 32 16.5079Z",
    fill: "#408E8D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 15.2381,
    rx: 11.0769,
    ry: 11.4286,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2953 13.1646L20.7638 21.1289L21.4312 17.7505L24.5846 16.5953L16.2953 13.1646Z",
    fill: "#408E8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9371 16.5952H8.00012L10.5087 18.8795L9.90346 22.2666L16.9371 16.5952Z",
    fill: "#ABE1FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.884 15.4517L18.3525 7.49029L15.1765 8.5844L12.6283 6.34961L13.884 15.4517Z",
    fill: "#FFC20E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilitiModeOff);
export default __webpack_public_path__ + "static/media/mobiliti_mode_off.dda02f45ad187efd761eee606296faf7.svg";
export { ForwardRef as ReactComponent };